function SettingsPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-semibold text-slate-900">Settings</h1>
      <p className="text-slate-600">
        Adjust your preferences and security settings for the Carewinners Admin workspace.
      </p>
    </div>
  );
}

export default SettingsPage;
